import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=67ad4402&scoped=true&lang=html&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"
import style0 from "./Card.vue?vue&type=style&index=0&id=67ad4402&prod&lang=css&scoped=true&"
import style1 from "./Card.vue?vue&type=style&index=1&id=67ad4402&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad4402",
  null
  
)

export default component.exports